export default __webpack_public_path__ + "static/media/new_order2.9ba9a1ab.png";